import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from 'containers/App';
import ErrorBoundary from 'components/ErrorBoundary';

import configureStore from './configureStore';

import './style/index.scss';

const initialState = {};
export const store = configureStore(initialState);
const root = ReactDOM.createRoot(document.getElementById('app'));

const render = () => {
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>,
  );
};

if (import.meta.hot) {
  import.meta.hot.accept(['./containers/App'], () => {
    render();
  });
}

render();
